import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async () => {
  return await dponetAPI.get('/ai_inventory_tools')
}

export default { get }
